'use client';

import React, { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { Badges } from '@/widgets/Badges';
import type { Badge } from '@/widgets/Badges';
import { DoctorAvatar } from '@/widgets/DoctorCard';
import baseIcons from '@/shared/assets/sprites/base.sprite.svg';
interface TitleSectionProps {
  children?: React.ReactNode;
  avatar: string;
  imgAlt: string;
  title: string;
  subtitle?: string;
  rating: number;
  reviewsCount: number;
  isTop?: boolean;
  avatarContain?: boolean;
}
export const TitleSection: React.FC<TitleSectionProps> = ({
  children,
  avatar,
  title,
  subtitle,
  rating,
  reviewsCount,
  imgAlt,
  isTop,
  avatarContain = false
}) => {
  const t = useTranslations();
  const [badges, setBadges] = useState<Badge[]>([]);
  const renderImage = () => {
    const imageSrc = avatar;
    const imageAlt = imgAlt || '';
    const imageProps = {
      className: 'w-24 [&>div>img]:rounded-2xl [&>div]:w-24 [&>div]:rounded-2xl [&>div]:border-2 [&>div]:border-bgSecondary',
      img: {
        alt: imageAlt,
        src: imageSrc || ''
      },
      sectionId: 'home',
      isLazy: true,
      isContainPhoto: avatarContain
    };
    return <DoctorAvatar {...imageProps} data-sentry-element="DoctorAvatar" data-sentry-component="renderImage" data-sentry-source-file="index.tsx" />;
  };
  useEffect(() => {
    const newBadges = [] as Badge[];
    if (isTop) {
      newBadges.push({
        type: 'top',
        label: t('doctor.profile.top')
      });
    }
    setBadges(newBadges);
  }, [isTop]);
  return <section className="flex flex-col gap-4" data-sentry-component="TitleSection" data-sentry-source-file="index.tsx">
      <div className="flex flex-row items-center text-left">
        {renderImage()}
        {badges.length > 0 && <Badges list={badges} position="right-top" />}
        <div className="flex flex-col gap-y-2 pl-4">
          {subtitle && <span className="text-sm text-textPrimary">{subtitle}</span>}
          <h1 translate="no" className="text-lg font-semibold">
            {title}
          </h1>
          <div className="flex flex-row items-center">
            <span className="flex flex-row items-center text-sm text-textPrimary md:text-sm">
              {t('doctor.profile.rating')}
              <svg className="mx-1 size-3 fill-current text-textPrimary" data-sentry-element="svg" data-sentry-source-file="index.tsx">
                <use xlinkHref={`${baseIcons}#star`} data-sentry-element="use" data-sentry-source-file="index.tsx"></use>
              </svg>
              {rating}
            </span>
            <span className="mx-1">•</span>
            <a href="#review" className="text-sm text-blue-500 hover:underline md:text-xs">
              {reviewsCount > 0 ? t('doctor.profile.reviews', {
              postProcess: 'interval',
              count: reviewsCount
            }) : t('doctor.profile.no_reviews')}
            </a>
          </div>
        </div>
      </div>
      {children}
    </section>;
};